import { systemEngineEnvironment } from "services/environment/systemEngine";

export const deleteDatabase = async (name: string) => {
  const result = await systemEngineEnvironment.execute(
    `DROP DATABASE IF EXISTS "${name}"`
  );
  return result;
};
